import { PATIENT, RESEARCHER, SUPER_RESEARCHER } from 'constants/userRoles';
import ReportsHistoryRow from './Row';
import PatientsRow from './Row/PatientsRow';
import ResearchersRow from './Row/ResearchersRow';

export const isResearcher = role => [RESEARCHER, SUPER_RESEARCHER].includes(role);

export const getTitleByRole = role => {
  switch (role) {
    case RESEARCHER:
      return 'deviceReportHistory';
    case SUPER_RESEARCHER:
      return 'deviceReportHistory';
    case PATIENT:
      return 'reports.reports';
    default:
      return 'reportHistory';
  }
};

export const getRowComponentByRole = role => {
  switch (role) {
    case RESEARCHER:
      return ResearchersRow;
    case SUPER_RESEARCHER:
      return ResearchersRow;
    case PATIENT:
      return PatientsRow;
    default:
      return ReportsHistoryRow;
  }
};

const patientsHeader = [
  { title: 'dateAndTime', sortKey: 'date' },
  { title: 'reports.reportBy' },
  { title: 'reports.deviceStatus' },
  { title: 'reports.reviewStatus', sortKey: 'status' },
];

const researchersHeader = [
  { title: 'dateAndTime', sortKey: 'date' },
  { title: 'reports.deviceStatus' },
  { title: 'reports.patientReviewStatus', sortKey: 'status' },
  { title: 'reports.completedBy' },
];

const defaultHeader = [
  { title: 'dateAndTime', sortKey: 'date' },
  { title: 'reports.deviceStatus' },
  { title: 'reports.completedBy' },
];

export const getTableHeaderByRole = role => {
  switch (role) {
    case RESEARCHER:
      return researchersHeader;
    case SUPER_RESEARCHER:
      return researchersHeader;
    case PATIENT:
      return patientsHeader;
    default:
      return defaultHeader;
  }
};
